import DatesUtils from "../utils/dates";

export default class CostService {

  static apiRelativePath = "/costs"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  search = async (start, end, type, category) => {
    return this.apiClient.get(`${CostService.apiRelativePath}/search`, {
      start_datetime: DatesUtils.formatDate(start),
      end_datetime: DatesUtils.formatDate(end),
      ...type && {type_id: type},
      ...category && {category_id: category}
    });
  }

  export = async (start, end, type, category) => {
    return this.apiClient.get(`${CostService.apiRelativePath}/export`, {
      start_datetime: DatesUtils.formatDate(start),
      end_datetime: DatesUtils.formatDate(end),
      ...type && {type_id: type},
      ...category && {category_id: category}
    });
  }

  create = async (data) => {
    return this.apiClient.post(`${CostService.apiRelativePath}`, data);
  }

  patch = async (id, data) => {
    return this.apiClient.patch(`${CostService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${CostService.apiRelativePath}/${id}`);
  }
}
